const JSONAPIDeserializer = require( 'jsonapi-serializer' ).Deserializer;

const deserializer = new JSONAPIDeserializer({ keyForAttribute: 'camelCase' });

export default {
  deserialize: ( something ) => deserializer.deserialize( something ),
};
